import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import { MainContainerStore } from "./main-container.store";
import { SidebarOpener } from "./main-container-sidebar-opener";

@Component({
  selector: "layout-main-container-header",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, SidebarOpener],
  template: `
    <layout-main-container-sidebar-opener [isOpen]="isSidebarOpen()" (toggled)="toggleSidebar()" />

    <a class="md:hidden absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" [routerLink]="'/'">
      <img src="assets/SaLa_favicon.svg" alt="SALA Logo" class="w-12" />
    </a>
    <div class="ml-auto flex items-center gap-4">
      <ng-content select="[right]" />
    </div>
  `,
  host: {
    class:
      "relative flex items-center border-b shadow-xs border-card-border bg-card text-card-foreground p-4",
    role: "banner",
  },
})
export class MainContainerHeader {
  // Dependencies
  readonly #mainContainerStore = inject(MainContainerStore);

  // Computeds
  readonly isSidebarOpen = this.#mainContainerStore.isSidebarOpen;

  toggleSidebar() {
    this.#mainContainerStore.toggleSidebarOpenState();
  }
}
